// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 850px) {
    .scl--web-page-differ-section .scl--wdacs-bo-car-con-st:nth-child(odd) .scl--dca-con-bo-str.border-right{
        border: none;
    }

    .scl--web-page-differ-section:nth-child(even) .scl--dca-con-bo-str.border-left{
        border: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/card/value/css/dynamicCardSt.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["@media (max-width: 850px) {\n    .scl--web-page-differ-section .scl--wdacs-bo-car-con-st:nth-child(odd) .scl--dca-con-bo-str.border-right{\n        border: none;\n    }\n\n    .scl--web-page-differ-section:nth-child(even) .scl--dca-con-bo-str.border-left{\n        border: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
